import React, { useState, useEffect, useRef } from "react"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import PenTool from './PenTool';

const Rotate360View = ({isTelop, isZoom, isPen, isEraser}) => {
  /**
   * 画像サイズ横幅
   * @type {number}
   */
  const content_w = window.config.appInfo.imageWidth;

  /**
   * 画像サイズ縦幅
   * @type {number}
   */
  const content_h = window.config.appInfo.imageHeight;
  /**
   * ウィンドウサイズ横幅
   * @type {number}
   */
  const [screen_w, setW] = useState(window.innerWidth - 40);    // 上部ボタン分調整

  /**
   * ウィンドウサイズ横幅
   * @type {number}
   */
  const [screen_h, setH] = useState(window.innerHeight - 84);   // 上部ボタン分調整

  /**
   * 画像サイズとウィンドウサイズの比率　横
   * @type {number}
   */
  const ratio_h = screen_w / content_w;

  /**
   * 画像サイズとウィンドウサイズの比率　縦
   * @type {number}
   */
  const ratio_v = screen_h / content_h;

  /**
   *  画像サイズとウィンドウサイズの比率
   * @type {number}
   */
  const ratio = ratio_v < ratio_h ? ratio_v : ratio_h;

  /**
   * 画像表示サイズ横幅
   * @type {number}
   */
  const area_w = content_w * ratio;

  /**
   * 画像表示サイズ横幅
   * @type {number}
   */
  const area_h = content_h * ratio;

  /**
   * 共通イメージ保存ディレクトリ
   * @type {string}
   */
  const commonImgDir = "./apps/common/";

  /**
   * イメージ保存ディレクトリ
   * @type {string}
   */
  const rotateImageDir = "./apps/images/";
  
  /**
   * 左回転ボタンイメージファイル
   * @type {string}
   */
  const leftRotateImg = "./apps/common/leftRotate.png";
  
  /**
   * 右回転ボタンイメージファイル
   * @type {string}
   */
  const rightRotateImg = "./apps/common/rightRotate.png";

   /**
   * 360度回転画像のindex数
   * @type {number}
   */
  const imageIndexTotal = 32;

  /**
   * 1画角変更に必要なポイント値
   * @type {number}
   */
  const angleChangePoint = 50;

  /**
   * 360度画像名
   * @type {string}
   */
  const imageName = window.config.appInfo.imageName;

  /**
   * 360度画像の拡張子
   * @type {string}
   */
  const imageFormat = window.config.appInfo.imageFormat;

  /**
   * 360度回転画像のindex値
   * @type {number}
   */
  const [imageIndex, setImageIndex] = useState(window.config.appInfo.defaultIndex);

  /**
   * テロップ情報
   * @type {telopInfo}
   */
  const telopInfo = window.config.telopInfo;

  /**
   * レイヤーメニューボタン情報
   * @type {layerMenuBtnInfo}
   */
  const layerMenuBtnInfo = window.config.layerMenuBtnInfo;

   /**
   * レイヤー情報
   * @type {layerInfos}
   */
  const layerInfos = window.config.layerInfos;

  /**
   * レイヤーメニューを開いているか
   * @type {bool}
   */
  const [isLayerMenuOpen, setIsLayerMenuOpen] = useState(false);

  /**
   * マウス(タッチ)ダウンのX座標値
   * @type {number}
   */
  const [downPosX, setDownPosX] = useState(0);

  /**
   * マウス(タッチ)ダウンされたか
   * @type {boolean}
   */
  const [isDown, setIsDown] = useState(false);

  /**
   * 回転動作フラグ
   * @type {boolean}
   */
  const [rotateFlag, setRotateFlag] = useState(false);

  /**
   * 回転インターバルID
   * @type {object}
   */
  const [intervalId, setIntervalId] = useState(null);

  /**
   * ドラッグフラグ
   * @type {number}
   */
  let dragFlag = 0;

  useEffect(() => {
    // 上部ボタン表示位置の設定
    setTopButtonPosition(area_w);
    // 360度回転画像のロード
    loadRotateImage();
    // テロップの設定
    setTelop();
    // レイヤーの設定
    setLayer();

    // 右クリックメニューは無効
    document.oncontextmenu = () => {
      return false;
    };

    window.addEventListener('resize', setWindowSize);
    return () => {
      window.removeEventListener('resize', setWindowSize);
    };
  }, [])

  useEffect(() => {
    // テロップ表示/非表示切り替え
    let telop = document.getElementById('telop');
    telop.style.display = (isPen || isEraser) ? "none" : (isTelop) ? "block" : "none";

    // トップのボタンの無効/有効切り替え
    let btnZoom = document.getElementById('btnZoom');
    let btnTelop = document.getElementById('btnTelop');
    btnZoom.disabled = (isPen || isEraser) ? true : false;
    btnZoom.style.opacity = (isPen || isEraser) ? 0.3 : 1;
    btnTelop.disabled = (isPen || isEraser) ? true : false;
    btnTelop.style.opacity = (isPen || isEraser) ? 0.3 : 1;

    let layerMenuBtn = document.getElementById("layerMenuBtn");
    layerMenuBtn.style.display = (isPen || isEraser) ? "none" : "block";

    if (isPen || isEraser){
      let layerMenuBtnImg = document.getElementById("layerMenuBtnImg");
      layerMenuBtnImg.src = commonImgDir + layerMenuBtnInfo.buttonOffImage;

      let hightoneImg = document.getElementById("hightoneImg");
      hightoneImg.style.display = "none";

      for (var i=0; i<layerInfos.length; i++) {
        let layerImg = document.getElementById("layerImg_" + String(i + 1));
        layerImg.style.display = "none";
        let layerBtn = document.getElementById("layerBtn_" + String(i + 1));
        layerBtn.style.display = "none";
        let layerBtnImg = document.getElementById("layerBtnImg_" + String(i + 1));
        layerBtnImg.src = commonImgDir + layerInfos[i].buttonOffImage;
      }

      setIsLayerMenuOpen(false);
    }

  }, [isPen, isEraser])

  useEffect(() => {
    let isLayerMenuEnabled = false;
    for (var i=0; i<layerInfos.length; i++) {
      let layerImg = document.getElementById("layerImg_" + String(i + 1));
      let layerBtn = document.getElementById("layerBtn_" + String(i + 1));

      // 画角が変わったら、レイヤー非表示、ボタン無効
      layerBtn.disabled = true;
      layerBtn.style.opacity = 0.3;

      // レイヤーが存在するか確認し、存在すればボタン押下可能とする
      if (layerInfos[i].existenceIndex.indexOf(('00' + imageIndex).slice(-2)) != -1) {
        layerBtn.disabled = false;
        layerBtn.style.opacity = 1;
        // レイヤー画像を変更
        layerImg.src = rotateImageDir + imageName + "_" + ('00' + imageIndex).slice(-2) + "_" + ('00' + String(i + 1)).slice(-2) + ".png";
        // レイヤーメニューボタンも押下可能とする
        isLayerMenuEnabled = true;
      }

      // レイヤーが存在する場合、ハイトーン画像を変更
      if (isLayerMenuEnabled) {
        let hightoneImg = document.getElementById("hightoneImg");
        hightoneImg.src = rotateImageDir + imageName + "_" + ('00' + (imageIndex)).slice(-2) + "_HT.png";
      }

      let layerMenuBtn = document.getElementById('layerMenuBtn');
      layerMenuBtn.disabled = (isLayerMenuEnabled) ? false : true;
      layerMenuBtn.style.opacity = (isLayerMenuEnabled) ? 1 : 0.3;
    }
  }, [imageIndex])


  /**
   * ウィンドウサイズの設定
   */
  const setWindowSize = function () {
    let width = window.innerWidth - 40;
    let height = window.innerHeight - 84;
    setW(width);
    setH(height);

    // 画面サイズ変更により画像サイズ、テロップ、レイヤー、ボタンの表示位置、サイズを調整
    if (width >= height * 16 / 9) {
      width = height * (16 / 9);
    }
    else {
      height = width * (9 / 16);
    }

    let ajustArea = document.getElementById('ajustArea');
    ajustArea.style.width = String(width) + "px";
    ajustArea.style.height = String(height) + "px";

    let telop = document.getElementById('telop');
    telop.style.width = String(width) + "px";
    telop.style.height = String(height) + "px";

    for (var i = 0; i < imageIndexTotal; i++) {
      let img = document.getElementById('rotateImg' + ('00' + (i + 1)).slice(-2));
      img.style.width = String(width) + "px";
      img.style.height = String(height) + "px";
    }

    setTopButtonPosition(width);
    setLayerSizePosition(width, height, width / content_w);
  };

  /**
   * 360度回転画像のロード
   */
  const loadRotateImage = function () {
    let zoomArea = document.getElementById('zoomArea');

    for (var i = 0; i < imageIndexTotal; i++) {
      let img = document.createElement('img');
      img.id = 'rotateImg' + ('00' + (i + 1)).slice(-2);
      img.src = rotateImageDir + imageName + "_" + ('00' + (i + 1)).slice(-2) + "." + imageFormat;
      img.style.position = "absolute";
      img.style.width = String(area_w) + "px";
      img.style.height = String(area_h) + "px";
      img.style.display = (i == (imageIndex - 1)) ? "block" : "none";
      zoomArea.appendChild(img);
    }
  }

  /**
   * 上部ボタン表示位置の設定
   * @param {number} width 横幅
   */
  const setTopButtonPosition = function (width) {
    let mLeft = (window.innerWidth - width) / 2;
    let btnZoom = document.getElementById('btnZoom');
    btnZoom.style.marginLeft = String(mLeft + width - 205) + "px";
  }
  
  /**
   * テロップの設定
   */
  const setTelop = function () {
    let telop = document.getElementById('telop');
    telop.src = rotateImageDir + telopInfo.fileName;
  }

  /**
   * レイヤーの設定
   */
  const setLayer = function () {

    let telop = document.getElementById('telop');
    let zoomArea = document.getElementById('zoomArea');

    // レイヤーメニューボタン
    let layerMenuBtn = document.createElement('button');
    layerMenuBtn.id = "layerMenuBtn";
    layerMenuBtn.style.position = "absolute";
    layerMenuBtn.style.zIndex = 100;
    layerMenuBtn.style.border = "none";
    layerMenuBtn.style.background = "transparent";
    layerMenuBtn.style.width = "0px";
    layerMenuBtn.style.height = "0px";
    layerMenuBtn.style.marginLeft = String(layerMenuBtnInfo.buttonLeft * ratio) + "px";
    layerMenuBtn.style.marginTop = String(layerMenuBtnInfo.buttonTop * ratio) + "px";
    layerMenuBtn.onclick = layerMenuOpenClose;
    // テロップの前に要素追加
    telop.before(layerMenuBtn);

    // レイヤーボタンイメージ
    let layerMenuBtnImg = document.createElement('img');
    layerMenuBtnImg.id = "layerMenuBtnImg";
    layerMenuBtnImg.src = commonImgDir + layerMenuBtnInfo.buttonOffImage;
    layerMenuBtnImg.style.width = String(layerMenuBtnInfo.buttonWidth * ratio) + "px";
    layerMenuBtnImg.style.height = String(layerMenuBtnInfo.buttonHeight * ratio) + "px";
    layerMenuBtnImg.style.position = "absolute";
    layerMenuBtnImg.style.zIndex = 101;
    layerMenuBtnImg.style.marginLeft = "-10px";
    layerMenuBtnImg.style.marginTop = "-5px";
    let list = layerMenuBtnImg.classList;
    list.add("icon_img");

      // レイヤーボタン内に追加
    layerMenuBtn.appendChild(layerMenuBtnImg);

    for (var i=0; i<layerInfos.length; i++) {
      // レイヤーボタン
      let layerBtn = document.createElement('button');
      layerBtn.id = "layerBtn_" + String(i + 1);
      layerBtn.style.position = "absolute";
      layerBtn.style.zIndex = 100;
      layerBtn.style.border = "none";
      layerBtn.style.background = "transparent";
      layerBtn.style.width = "0px";
      layerBtn.style.height = "0px";
      layerBtn.style.marginLeft = String(layerInfos[i].buttonLeft * ratio) + "px";
      layerBtn.style.marginTop = String(layerInfos[i].buttonTop * ratio) + "px";
      layerBtn.onclick = changeLayer;
      // テロップの前に要素追加
      telop.before(layerBtn);

    // レイヤーボタン内イメージ
      let layerBtnImg = document.createElement('img');
      layerBtnImg.id = "layerBtnImg_" + String(i + 1);
      layerBtnImg.src = commonImgDir + layerInfos[i].buttonOffImage;
      layerBtnImg.style.width = String(layerInfos[i].buttonWidth * ratio) + "px";
      layerBtnImg.style.height = String(layerInfos[i].buttonHeight * ratio) + "px";
      layerBtnImg.style.marginLeft = "-10px";
      layerBtnImg.style.marginTop = "-5px";
      layerBtnImg.style.position = "absolute";
      layerBtnImg.style.zIndex = 101;
      list = layerBtnImg.classList;
      list.add("icon_img");
  
      // レイヤーボタン内に追加
      layerBtn.appendChild(layerBtnImg);

      // レイヤーボタンは初回時非表示
      layerBtn.style.display = "none";

      // レイヤーイメージ
      let layerImg = document.createElement('img');
      layerImg.id = "layerImg_" + String(i + 1);
      layerImg.src = rotateImageDir + imageName + "_" + ('00' + imageIndex).slice(-2) + "_" + ('00' + String(i + 1)).slice(-2) + ".png";
      layerImg.style.position = "absolute";
      layerImg.style.zIndex = 50 - i;
      layerImg.style.width = String(area_w) + "px";
      layerImg.style.height = String(area_h) + "px";
      layerImg.style.display = "none";

      // ズームエリア内に追加
      zoomArea.appendChild(layerImg);
    }
  }

  /**
   * レイヤー関連のサイズ、表示位置の設定
   * @param {number} width 横幅
   * @param {number} height 縦幅
   * @param {number} ratio 比率
   */
  const setLayerSizePosition = function (width, height, ratio) {
    let layerMenuBtn = document.getElementById("layerMenuBtn");
    layerMenuBtn.style.marginLeft = String(layerMenuBtnInfo.buttonLeft * ratio) + "px";
    layerMenuBtn.style.marginTop = String(layerMenuBtnInfo.buttonTop * ratio) + "px";

    let layerMenuBtnImg = document.getElementById("layerMenuBtnImg");
    layerMenuBtnImg.style.width = String(layerMenuBtnInfo.buttonWidth * ratio) + "px";
    layerMenuBtnImg.style.height = String(layerMenuBtnInfo.buttonHeight * ratio) + "px";

    for (var i=0; i<layerInfos.length; i++) {
      let layerImg = document.getElementById("layerImg_" + String(i + 1));
      layerImg.style.width = String(width) + "px";
      layerImg.style.height = String(height) + "px";

      let layerBtn = document.getElementById("layerBtn_" + String(i + 1));
      layerBtn.style.marginLeft = String(layerInfos[i].buttonLeft * ratio) + "px";
      layerBtn.style.marginTop = String(layerInfos[i].buttonTop * ratio) + "px";

      let layerBtnImg = document.getElementById("layerBtnImg_" + String(i + 1));
      layerBtnImg.style.width = String(layerInfos[i].buttonWidth * ratio) + "px";
      layerBtnImg.style.height = String(layerInfos[i].buttonHeight * ratio) + "px";
    }
  }

  /**
   * 全角半角を区別して長さ（文字数）を取得
   * @param {string} str 長さを取得する文字列
   * @param {'UTF-8'|'Shift_JIS'} [encode='Shift_JIS'] 文字コード
   * @return {number} 文字数を返す
   */
  const strLength = function(str, encode) {
	  var count = 0,
	   setEncode = 'Shift_JIS',
	   c = '';

    if (encode && encode !== '') {
     	if (encode.match(/^(SJIS|Shift[_\-]JIS)$/i)) {
	      setEncode = 'Shift_JIS';
	    } else if (encode.match(/^(UTF-?8)$/i)) {
			  setEncode = 'UTF-8';
		  }
	  }

    for (var i = 0, len = str.length; i < len; i++) {
		  c = str.charCodeAt(i);
		  if (setEncode === 'UTF-8') {
		    if ((c >= 0x0 && c < 0x81) || (c == 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
		      count += 1;
			  } else {
			    count += 2;
			  }
		  } else if (setEncode === 'Shift_JIS') {
			  if ((c >= 0x0 && c < 0x81) || (c == 0xa0) || (c >= 0xa1 && c < 0xdf) || (c >= 0xfd && c < 0xff)) {
			    count += 1;
			  } else {
			    count += 2;
			  }
		  }
	  }
  	return count;
  };

  /**
   * レイヤーメニュオープンクローズ切り替え
   */
  const layerMenuOpenClose = () => {
    let layerMenuBtnImg = document.getElementById("layerMenuBtnImg");
    let isDisplay = false;
    if ((layerMenuBtnImg.src.indexOf('_on.png') != -1)) {
      // レイヤーメニューを閉じる
      layerMenuBtnImg.src = commonImgDir + layerMenuBtnInfo.buttonOffImage;
    } else {
      // レイヤーメニューを開く
      layerMenuBtnImg.src = commonImgDir + layerMenuBtnInfo.buttonOnImage;;
      isDisplay = true;
    }

    setIsLayerMenuOpen(isDisplay);

    // ハイトーン画像を表示、非表示
    let hightoneImg = document.getElementById("hightoneImg");
    hightoneImg.style.display = (isDisplay) ? "block" : "none";

    for (var i=0; i<layerInfos.length; i++) {
      let layerBtn = document.getElementById("layerBtn_" + String(i + 1));
      layerBtn.style.display = (isDisplay) ? "block" : "none";
      // レイヤーメニューを閉じた場合、表示中のレイヤーは非表示
      if (!isDisplay) {
        let layerImg = document.getElementById("layerImg_" + String(i + 1));
        layerImg.style.display = "none";

        // ボタンの色を元に戻す
        let layerBtnImg = document.getElementById("layerBtnImg_" + String(i + 1));
        layerBtnImg.src = commonImgDir + layerInfos[i].buttonOffImage;
      }
    }
  }

  /**
   * レイヤー表示/非表示切り替え
   * @param {} e クリックイベント
   */
  const changeLayer = (e) => {
    let targetId = e.currentTarget.id;
    let targetSplit = targetId.split("_");
    let layer = document.getElementById('layerImg_' + targetSplit[1]);
    let layerBtnImg = document.getElementById('layerBtnImg_' + targetSplit[1]);
    let infoIndex = targetSplit[1] - 1;
    if (layer.style.display === "block") {
      // 非表示
      layer.style.display = "none";
      layerBtnImg.src = commonImgDir + layerInfos[infoIndex].buttonOffImage;
    } else {
      // 表示
      layer.style.display = "block";
      layerBtnImg.src = commonImgDir + layerInfos[infoIndex].buttonOnImage;
    }
  }

  /**
   * 回転開始
   * @param {any} e クリックイベント
   */
  const rotateStart = (e) => {
    if (!isDown && !isZoom && !isPen && !isEraser && !isLayerMenuOpen) {
      let x;
      if (e.changedTouches) {
        x = e.changedTouches[0].pageX;
      }
      else {
        x = e.pageX;
      }
      setDownPosX(x);
      setIsDown(true);
    }
  }

  /**
   * 回転
   * @param {any} e クリックイベント
   */
  const rotate = (e) => {
    if (isDown && !isZoom && !isPen && !isEraser && !isLayerMenuOpen) {
      let index = imageIndex;
      let x;
      if (e.changedTouches) {
        x = e.changedTouches[0].pageX;
      }
      else {
        x = e.pageX;
      }
      let movedPoint = x - downPosX;
      // 1画角変更とみなすポイント数になるまでは何もしない
      if (movedPoint < angleChangePoint && movedPoint > angleChangePoint * -1) {
        return;
      }

      if (!rotateFlag) {
        setRotateFlag(true);
      }

      if (movedPoint > 0) {
        index--;
      }
      else {
        index++;
      }
      setDownPosX(x);
      (index > imageIndexTotal) ? index = 1 : (index == 0) ? index = imageIndexTotal : index = index;
      changeImage(index);
    }
  }

  /**
   * 回転終了
   */
  const rotateEnd = () => {
    if (isDown && !isZoom && !isPen && !isEraser && !isLayerMenuOpen) {
      setRotateFlag(false);
    }
    setIsDown(false);
  }

  /**
    * 表示画像を変更
    * @param {number} index 画像インデックス
    */
  const changeImage = (index) => {
    setImageIndex(index);

    for (var i = 0; i < imageIndexTotal; i++) {
      let img = document.getElementById('rotateImg' + ('00' + (i + 1)).slice(-2));
      img.style.display = (i == (index - 1)) ? "block" : "none";
    }
  }

  /**
   * ボタンによる回転開始
   * @param {} e クリックイベント
   */
  const rotateStartForBtn = (e) => {
 
    // 既に回転中の場合、何もしない
    if (rotateFlag) {
      return false;
    }

    setRotateFlag(true);
    let targetId = e.currentTarget.id;
    let isLeft = (targetId.indexOf('Left') != -1) ? true : false;
    let index = imageIndex;

    let btn = document.getElementById(targetId);
    btn.style.opacity = 0.7;

    // ボタン押下直後に画角を1つ変更
    (isLeft) ? index++ : index--;
    (index > imageIndexTotal) ? index = 1 : (index == 0) ? index = imageIndexTotal : index = index;
    changeImage(index);

    // ボタン押下中はインターバルを設けて画角を変更
    let _intervalId = setInterval(() => {
      (isLeft) ? index++ : index--;
      (index > imageIndexTotal) ? index = 1 : (index == 0) ? index = imageIndexTotal : index = index;
      changeImage(index);

    }, 150);
    setIntervalId(_intervalId);
  }

  /**
   * ボタンによる回転終了
   */
  const rotateEndForBtn = (e) => {
    let btn = document.getElementById(e.currentTarget.id);
    btn.style.opacity = 1;

    if (intervalId != null) {
      clearInterval(intervalId);
      setIntervalId(null);
      setRotateFlag(false);
    }
  }

  return (
    <div id="ajustArea" className="ajustArea print_area" style={{ width: area_w, height: area_h, margin: '0 auto' }}>
      <img id='telop' className='telop' style={{ width: area_w, height: area_h, pointerEvents: 'none'}}></img>
      <button id="btnLeft" className="rotate_button"
        style={{ width: 75 * ratio, height: 75 * ratio, padding: 0, borderRadius: 2, border: "none", background: "transparent", marginLeft: 10 * ratio, marginTop: area_h / 2, display: (!isZoom && !isPen && !isEraser && !isLayerMenuOpen) ? "block" : "none"}}
        onTouchStart={(e) => { rotateStartForBtn(e); }}
        onMouseDown={(e) => { rotateStartForBtn(e); }}
        onMouseUp={(e) => { rotateEndForBtn(e); }}
        onMouseLeave={(e) => { rotateEndForBtn(e); }}
        onTouchMove={(e) => { rotateEndForBtn(e); }}
        onTouchEnd={(e) => { rotateEndForBtn(e); }}
        onTouchCancel={(e) => { rotateEndForBtn(e); }}
      >
        <img src={leftRotateImg} className='icon_img' style={{ width: 75 * ratio, height: 75 * ratio}}></img>
      </button>
      <button id="btnRight" className="rotate_button"
        style={{ width: 75 * ratio, height: 75 * ratio, padding: 0, borderRadius: 2,border: "none", background: "transparent", marginLeft: area_w - (85 * ratio), marginTop: area_h / 2, display: (!isZoom && !isPen && !isEraser && !isLayerMenuOpen) ? "block" : "none"}}
        onTouchStart={(e) => { rotateStartForBtn(e); }}
        onMouseDown={(e) => { rotateStartForBtn(e); }}
        onMouseUp={(e) => { rotateEndForBtn(e); }}
        onMouseLeave={(e) => { rotateEndForBtn(e); }}
        onTouchMove={(e) => { rotateEndForBtn(e); }}
        onTouchEnd={(e) => { rotateEndForBtn(e); }}
        onTouchCancel={(e) => { rotateEndForBtn(e); }}
      >
        <img src={rightRotateImg} className='icon_img' style={{ width: 75 * ratio, height: 75 * ratio}}></img>
      </button>
      <TransformWrapper doubleClick={{ disabled: !isZoom, step:1 }} pinch={{ disabled: !isZoom, step: 0.2 }} wheel={{ disabled: !isZoom, step: 0.2 }}
        panning={{ disabled: !isZoom}} maxScale={2} >
        {({ instance, state }) => (
          <React.Fragment>
            <TransformComponent>
            <div id="zoomArea" style={{
              width: area_w - 2, height: area_h - 2,
              position: "relative"
            }}
              onTouchStart={(e) => { rotateStart(e); }}
              onMouseDown={(e) => {
                dragFlag = 0;
                rotateStart(e);
              }}
              onTouchMove={(e) => { rotate(e); }}
              onMouseMove={(e) => {
                dragFlag++;
                rotate(e);
              }}
              onMouseUp={() => { rotateEnd(); }}
              onMouseLeave={() => { rotateEnd(); }}
              onTouchEnd={() => { rotateEnd(); }}
              onTouchCancel={() => { rotateEnd(); }}
              onClick={(e) => {
                if (isZoom && (dragFlag < 5)) {
                  instance.setup.doubleClick.mode = state.scale !== 1 ? "zoomOut" : "zoomIn";

                  // const event = new MouseEvent("dblclick", e); // IE11以外はこちらでOK
                  // 非推奨、モダンブラウザで動かなくなったら上を使う
                  let event = document.createEvent("MouseEvents");
                  event.initMouseEvent("dblclick", e.bubbles, e.cancelable, e.view, e.detail, e.screenX, e.screenY, e.clientX, e.clientY,
                    e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
                  document.getElementById("zoomArea").dispatchEvent(event);
                }
              }}>
              <PenTool imageIndex={imageIndex} content_w={content_w} content_h={content_h}/>
              <img id='hightoneImg' style={{ width: area_w, height: area_h, display: 'none', pointerEvents: 'none', position: "absolute", zIndex: 10}}></img>
            </div>
            </TransformComponent>
          </React.Fragment>
        )}
      </TransformWrapper>
    </div >
  )
}

export default Rotate360View